import { useNavigate, useParams } from "react-router-dom";

const Error404 = () => {
  const navigate = useNavigate();
  const { lang } = useParams();

  return (
    <>
      <p>not found</p>
      <button onClick={() => navigate(`/${lang}`)}>Go home</button>
    </>
  );
};

export default Error404;
